(ns assemble.templates-page.view
  (:require ["@mui/material/Stack$default" :as Stack]
            [assemble.assets-page.drawer.folders :as folders-drawer]
            [assemble.component.move-modal.db :as move-modal.db]
            [assemble.component.move-modal.view :refer [move-modal]]
            [assemble.component.new-folder :as new-folder]
            [assemble.component.upload :as upload]
            [assemble.resource.template :as resource.template]
            [assemble.sidebar :refer [sidebar-content]]
            [assemble.templates-page.drawer.view :as templates-drawer]
            [assemble.templates-page.table :refer [templates-table]]
            [assemble.templates-page.upload-modal.db :as upload-modal.db]
            [assemble.templates-page.upload-modal.view :refer [new-template-modal]]
            [common.util :refer [spread-obj]]
            [common.widgets.page :as page]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui asset-buttons []
  ($ :<>
     ($ new-folder/new-folder-button)
     ($ upload/upload-button {:on-click #(rf/dispatch [::upload-modal.db/open {:files nil}])})))

(defui templates-page []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [sub-title]} (use-subscribe [:router/route-data])
        show-asset-buttons? (use-subscribe [::resource.template/disable-feature-for-pre-made-templates?])
        {node-id :asset-tree/id :as node} (use-subscribe [:assemble.page.assets.file-tree/current-node])
        os-enabled? (use-subscribe [:common.os/enabled])]
    (uix/use-effect (fn []
                      (when node
                        (rf/dispatch [::resource.template/get-all-by-node node])))
                    [advertiser-id node])
    (uix/use-effect (fn []
                      (when node-id
                        (rf/dispatch [::resource.template/get-public-pre-made-templates node-id])))
                    [advertiser-id node-id])
    ($ :<>
       ($ new-template-modal)
       ($ move-modal
          {:on-submit-event [::move-modal.db/check-for-folder-submit-event]
           :type :template})
       ($ new-folder/new-folder-modal)
       ($ page/page
          {:title (str "Assemble - " sub-title)
           :sx #js {:backgroundColor "white"
                    :marginLeft 3
                    :borderRadius 2}
           :content-sx (spread-obj #js {:py 3}
                                   (if os-enabled?
                                     page/wpp-os-content-padding-sx
                                     page/content-padding-sx))
           :page-sx #js {:backgroundColor "grey.90"}
           :sidebar-sx #js {:borderRadius 2
                            :borderRight 0
                            :overflow "hidden"}
           :sidebar-toggle? false
           :sidebar-content ($ sidebar-content
                               {:type :templates})}
          ($ page/page-header
             (cond-> {:title sub-title}
               show-asset-buttons? (assoc :buttons ($ asset-buttons))))
          ($ Stack
             {:direction "row"
              :flex 1
              :sx #js {:overflow "hidden"}}
             ($ templates-table)
             ($ templates-drawer/templates-drawer)
             ($ folders-drawer/folders-drawer))))))
